import {createReducer, on} from "@ngrx/store";
import {RelatedCasesActions} from "../actions";
import {RelatedCasesDto} from "@esa/api";

export const relatedCasesFeatureKey = 'relatedCases';

export interface RelatedCasesState {
  relatedCases: RelatedCasesDto[];
}

const initialState: RelatedCasesState = {
  relatedCases: []
};

export const relatedCasesReducer = createReducer(
  initialState,
  on(RelatedCasesActions.getRelatedCasesByIdSuccess, (state, { relatedCases }) => ({ ...state, relatedCases })),
);
